module.exports = __webpack_public_path__ + "static/media/opakowania_01_C.84cd7bdc.png";